import type { ThemeMode } from '@/hooks/useLightMode'

import { Flex, Stack, Text, Toggle } from '@hivewatch/dark'

import { settingsColorToken } from '@/features/settings'

interface SettingsToggleRowIProps {
  colorScheme: ThemeMode
  label: string
  helperText?: string
  isOn: boolean
  disabled?: boolean
  onChange: (isOn: boolean) => void
  dataTestId?: string
}

export const SettingsToggleRow = ({
  colorScheme,
  label,
  helperText,
  isOn,
  disabled = false,
  onChange,
  dataTestId,
}: SettingsToggleRowIProps) => (
  <Flex alignItems='center' gap='16px' justifyContent='space-between' w='full'>
    <Stack gap='2px'>
      <Text
        color={settingsColorToken(colorScheme, 'text.primary')}
        textStyle='label'
      >
        {label}
      </Text>
      {helperText && (
        <Text
          color={settingsColorToken(colorScheme, 'text.secondary')}
          textStyle='caption'
        >
          {helperText}
        </Text>
      )}
    </Stack>
    <Toggle
      aria-label={label}
      colorScheme={colorScheme}
      data-testid={dataTestId}
      disabled={disabled}
      isOn={isOn}
      onChange={onChange}
    />
  </Flex>
)
